module.exports = __webpack_public_path__ + "static/img/9.3cf6389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/9.png
// module id = 9EXp
// module chunks = 1